import React, { useState } from "react";
import { Input, Select, Form, Button, Checkbox } from 'antd';
import { initialValuesUsuarioJuridicoModel, UsuarioModel } from "../../../../models/UsuariosModel/usuarios.model";
import { useNavigate } from "react-router";
import { useLocations } from "../../../../hooks/useLocations";
import { useRegitrarUsuarioUME } from "../../../../hooks/useRegitrarUsuarioUME";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalDireccion } from "../../../../components/ModalDireccion/ModalDireccion";
import { Municipio } from "../../../../models/LocationsModels/locations.models";
import apiLocation from "../../../../api/Participantes/api.location";
import { InputTexto } from "../../../../components/Mascaras/InputTexto/InputTexto";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { InputNumero } from "../../../../components/Mascaras/InputNumero/InputNumero";
import { comunasOptions } from "../../../../utils/dataSelectOptions";



const PersonaNatural = () => {

  const [municipios, setMunicipios] = useState<Municipio[]>([]);
  const [department, setDepartment] = useState(true);
  const [diparmentShow, setDiparmentShow] = useState<any>(true);
  const [usuario, setUsuario] = useState<UsuarioModel>(initialValuesUsuarioJuridicoModel);
  const [openModal, setOpenModal] = useState(false);
  const [barrios, setBarrios] = useState([]);
  const [visibleFields, setVisibleFields] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState<any>({nombre: '', tipoDocumento: ''});
  const [modalvisualizardocumento, setModalVisualizarDocumento] = useState(false);

  const { paises, departamentos, comunas } = useLocations();
  const navigate = useNavigate();
  const { guardarUsuario } = useRegitrarUsuarioUME();

  const terminos = () => {
    setTipoDocumento({
      nombre: 'terminosycondiciones.pdf',
      tipoDocumento: 'terminos'
    })
    setModalVisualizarDocumento(true);
  }

  const politicas = () => {
    setTipoDocumento({
      nombre: 'politicasdeuso.pdf',
      tipoDocumento: 'politicasUso'
    })
    setModalVisualizarDocumento(true);
  }

  const registrarUsuario = async () => {

    const { municipio_nombre, departamento_nombre, barrio_nombre, comuna_nombre, comuna, tipo_telefono, ...datos } = usuario;

    setUsuario({
      ...usuario,
      genero: "o",
    });

    if (!usuario.politica)
      return openNotification({
        titulo: "Error",
        descripcion: "Falta aceptar las politicas de uso",
        placement: "bottomRight",
      });

    const { data } = await guardarUsuario(datos);

    if (data.success === "0") {
      return openNotification({
        titulo: "Error",
        descripcion: data.message,
        placement: "bottomRight",
      });
    }

    return navigate("/usuario/RegistroExitoso");
  };



  const handleDisabledDepartment = (e: any) => {
    console.log(e);
    if (e === "CO") {
      return setDepartment(false);
    }
    setUsuario({
      ...usuario,
      pais: e,
      departamento_nombre: null,
      departamento: "",
    });
    return setDepartment(true);
  };

  const handleDepartamento = async (departamento: string) => {
    try {
      const datosDepartameto = departamento.split("-");
      setUsuario({
        ...usuario,
        departamento_nombre: `${datosDepartameto[1]}`,
        departamento: `0${datosDepartameto[0]}-${datosDepartameto[1]}`,
        municipio_nombre: "",
        municipio: "",
        comuna_nombre: "",
        comuna: "",
        barrio_nombre: "",
      });


      const municipios = await apiLocation.obtenerMunicipios(
        datosDepartameto[0]
      );
      return setMunicipios(municipios);
    } catch (error) {
      return console.error(error);
    }
  };



  const handleMunicipio = async (municipio: string) => {
    try {
      const datosMunicipio = municipio.split("-");

      if (datosMunicipio[1] === "MEDELLÍN") {
        setUsuario({
          ...usuario,
          municipio_nombre: `${datosMunicipio[1]}`,
          municipio: `0${datosMunicipio[0]}-${datosMunicipio[1]}`,
          comuna_nombre: "",
          comuna: "",
          barrio_nombre: "",
          barrio: "",
        });

        return setVisibleFields(true);
      }

      setUsuario({
        ...usuario,
        municipio_nombre: `${datosMunicipio[1]}`,
        municipio: `0${datosMunicipio[0]}-${datosMunicipio[1]}`,
        comuna_nombre: "",
        comuna: "",
        barrio_nombre: "",
        barrio: "",
        genero: "o",
      });


      return setVisibleFields(false);
    } catch (error) {
      return console.log(error);
    }
  };

  const handleComunas = async (comuna: string) => {
    try {
      const datosComuna = comuna.split("-");

      setUsuario({
        ...usuario,
        comuna_nombre: `${datosComuna[1]}`,
        comuna: `0${datosComuna[0]}-${datosComuna[1]}`,
        barrio_nombre: "",
        barrio: "",
      });

      const barrios = await apiLocation.obtenerBarrios(datosComuna[0]);
      setBarrios(barrios);
    } catch (error) {
      return console.log(error);
    }
  };

  const handleBarrios = async (barrio: string) => {
    try {
      const datosBarrio = barrio.split("-");
      setUsuario({
        ...usuario,
        barrio_nombre: `${datosBarrio[1]}`,
        barrio: `${datosBarrio[1]}`,
      });
    } catch (error) {
      return console.log(error);
    }
  };

  const handelDireccion = (e: any) => {
    console.log(e);
    let direccion = e.target.value.trim();
    console.log(direccion);
    return setUsuario({
      ...usuario,
      direccion: direccion,
    });
  };

  const fields = [
    { name: "tipo_sociedad", value: usuario.tipo_sociedad },
    { name: "tipo_entidad", value: usuario.tipo_entidad },
    { name: "tipo_identificacion", value: usuario.tipo_identificacion },
    { name: "documento", value: usuario.documento },
    { name: "nombres", value: usuario.nombres },
    { name: "apellidos", value: usuario.apellidos },
    { name: "correo", value: usuario.correo },
    { name: "direccion", value: usuario.direccion },
    { name: "barrio", value: usuario.barrio },
    { name: "barrio_nombre", value: usuario.barrio_nombre },
    { name: "telefono", value: usuario.telefono },
    { name: "tipo_telefono", value: usuario.tipo_telefono },
    { name: "celular", value: usuario.celular },
    { name: "pais", value: usuario.pais },
    { name: "departamento", value: usuario.departamento },
    { name: "departamento_nombre", value: usuario.departamento_nombre },
    { name: "municipio", value: usuario.municipio },
    { name: "municipio_nombre", value: usuario.municipio_nombre },
    { name: "comuna", value: usuario.comuna },
    { name: "comuna_nombre", value: usuario.comuna_nombre },
    { name: "genero", value: usuario.genero },
    { name: "notificacion", value: usuario.notificacion },
    { name: "politica", value: usuario.politica },
  ];

  return (
    <div>
      {
        //@ts-ignore
        <Form
          layout="vertical"
          size="large"
          onFinish={registrarUsuario}
          fields={fields}
          onFieldsChange={(_: any, fields: any) => {
            let infoupdate: any = { ...usuario };
            infoupdate[_[0].name[0]] = _[0].value;
            return setUsuario(infoupdate);
          }}
        >
          <div className="row">
            <div className="col-12 col-md-4">
              <Form.Item
                label={
                  <>
                    NIT
                  </>
                }
                name="documento"
                rules={[
                  { required: true, message: "Campo obligatorio" },
                  { min: 9, message: "El NIT debe tener mínimo 9 números" },
                ]}
              >
                <InputNumero max={10} name="documento" placeholder="No." texto={usuario.documento} setTexto={setUsuario} alltexto={usuario} />
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                label={
                  <>
                    Tipo de entidad
                  </>
                }
                name="tipo_entidad"
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                ]}
              >
                <Select placeholder="Seleccionar tipo de entidad..." onChange={(value: any) => {
                  setUsuario({
                    ...usuario,
                    tipo_entidad: value

                  });
                }}>
                  {/* <Select.Option value="NINGUNO" selected="">Seleccione...</Select.Option> */}
                  <Select.Option value="O-ORGANIZACIÓN SIN ÁNIMO DE LUCRO">
                    ORGANIZACIÓN SIN ÁNIMO DE LUCRO
                  </Select.Option>
                  <Select.Option value="T-OTRO">OTRO</Select.Option>
                  <Select.Option value="R-PRIVADA">PRIVADA</Select.Option>
                  <Select.Option value="P-PÚBLICA">PÚBLICA</Select.Option>
                </Select>
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                label={
                  <>
                    Nombre o razón social
                  </>
                }
                name="nombres"
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                ]}
              >
                {/* <Input placeholder=""  /> */}
                <InputTexto
                  name="nombres"
                  texto={usuario.nombres}
                  setTexto={setUsuario}
                  alltexto={usuario}
                  onInput={usuario.nombres}
                />
              </Form.Item>
            </div>

            {/* <div className="col-12 col-md-4">
            <Form.Item hidden className="no-margin" name="genero" label="Género" rules={[
                {
                  required: true,
                  message: "",
                },
              ]}>
              <Select style={{ width: "100%" }} placeholder="Seleccionar...">
                {IdentidadGeneroUMEOptions.map(({ value, text }) => (
                  <Select.Option key={value} value={value}>
                    {text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div> */}

            <div className="col-12 col-md-4">
              <Form.Item
                label={
                  <>
                    Correo electrónico
                  </>
                }
                name="correo"
                rules={[
                  {
                    type: "email",
                    message: "El correo electrónico es invalido",
                  },
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                ]}
              >
                <Input placeholder="" />
              </Form.Item>
            </div>
            <div className="col-12 col-md-4">
              <div className="row g-2">
                <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353">
                  Teléfono comercial - <span className="font-family-Montserrat-Regular font-size-10px">&nbsp;Opcional</span>
                </span>
                <div className="col-4">
                  <Form.Item
                    // label="Teléfono comercial*"
                    name="tipo_telefono"
                    rules={[
                      // {
                      //   required: true,
                      //   message: "Campo obligatorio",
                      // },
                    ]}
                  >
                    <Select>
                      <Select.Option value="Fijo">Fijo</Select.Option>
                      <Select.Option value="Movil">Móvil</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-8">
                  <Form.Item
                    // label=" "
                    name={usuario.tipo_telefono === "Movil" ? "celular" : "telefono"}
                    rules={[
                      // { required: true, message: "Campo obligatorio",},
                      { min: 7, message: "Mínimo 7 números", },
                    ]}
                  >
                    <InputNumero max={10} name={usuario.tipo_telefono === "Movil" ? "celular" : "telefono"} placeholder="Número:" texto={usuario.tipo_telefono === "Movil" ? usuario.celular : usuario.telefono} setTexto={setUsuario} alltexto={usuario} />
                    {/* <Input placeholder="Número:" /> */}
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <Form.Item
                label={
                  <>
                    Dirección comercial
                  </>
                }

                name="direccion"
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                ]}
              >
                <Input
                  onClick={() => setOpenModal(true)}
                  autoComplete="off"
                  onBlur={(e: any) => handelDireccion(e)}
                  readOnly
                />
              </Form.Item>
            </div>
            {/* <div className="col-12 col-md-4">
              <Form.Item
                label="Barrio"
                name="barrio_empresa"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input placeholder="" />
              </Form.Item>
            </div> */}
            <div className="col-12 col-md-4">
              <Form.Item
                label={
                  <>
                    País
                  </>
                }
                name="pais"
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                ]}
              >
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Seleccionar..."
                  onChange={(e: any) => handleDisabledDepartment(e)}
                >
                  {paises.map(({ id, prefijo, nombre }) => (
                    <Select.Option key={id} value={prefijo}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div
              className={
                diparmentShow ? "showFild, col-12 col-md-4" : "hideFild"
              }
            >
              <Form.Item
                label="Departamento"
                name="departamento_nombre"
                rules={[
                  (usuario.pais === "CO" &&
                  {
                    required: true,
                    message: "Campo obligatorio",
                  }
                  )

                ]}
              >

                <Select
                  placeholder="Seleccionar..." onChange={handleDepartamento} disabled={department}>
                  {departamentos.map(({ id, nombre }) => (
                    <Select.Option key={id} value={`${id}-${nombre}`}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div
              className={
                diparmentShow ? "showFild, col-12 col-md-4" : "hideFild"
              }
            >
              {/* <label className="color-label">Ciudad</label> */}
              <Form.Item
                label="Ciudad"
                name="municipio_nombre"
                rules={[
                  ((usuario.pais === "CO" && usuario.departamento !== "") &&
                  {
                    required: true,
                    message: "Campo obligatorio",
                  }
                  )

                ]}
              >
                <Select
                  onChange={handleMunicipio}
                  placeholder="Seleccionar..."
                  disabled={municipios.length === 0 ? true : false}

                >
                  {municipios?.map(({ id, nombre }) => (
                    <Select.Option key={id} value={`${id}-${nombre}`}>
                      {nombre}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            {visibleFields && (
              <div className="col-12 col-md-4">
                <Form.Item label="Comuna de residencia" name="comuna_nombre">
                  <Select onChange={handleComunas}>
                    {comunasOptions.map(({ key, value }: any) => (
                      <Select.Option key={key} value={`${key}-${value}`}>
                        {key} - {value}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {visibleFields && (
              <div className="col-12 col-md-4">
                <Form.Item label="Barrio de residencia" name="barrio_nombre">
                  <Select onChange={handleBarrios}>
                    {barrios?.map(({ id, nombre }: any) => (
                      <Select.Option
                        key={id}
                        value={`${id}-${nombre.toUpperCase()}`}
                      >
                        {nombre}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}
          </div>
          <div className="mt-3">
            <div className="col">
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <Checkbox
                  checked={usuario.politica}

                  onChange={(e: any) => {
                    console.log(e.target);

                    setUsuario({ ...usuario, politica: e.target.checked })
                  }}
                >
                  <div className="no-margin font-size-12px">
                    Acepto <span className="no-margin font-color-051923bf font-size-12px" onClick={politicas}>Políticas de uso</span> y los{" "}
                    <span className="no-margin font-color-051923bf font-size-12px terminos" onClick={terminos}>Términos y condiciones</span>
                  </div>
                </Checkbox>

              </div>
            </div>
          </div>
          <div className="row btn_con_re">
            <div className="col justify-content-flex-end">
              <Button
                type="primary"
                htmlType="submit"
                className="button-azul-radius"
              >
                Continuar
              </Button>
            </div>
          </div>
        </Form>
      }
      <ModalDireccion
        modal={openModal}
        CancelarModal={() => setOpenModal(false)}
        AceptarModal={() => setOpenModal(false)}
        directions={usuario}
        setDireccion={setUsuario}
        namedirections="direccion"
      />
      <ModalVisualizarDocumentos
        visualizar={modalvisualizardocumento}
        setVisualizar={setModalVisualizarDocumento}
        state={{ documento: tipoDocumento.nombre }}
        tipoDocumento={tipoDocumento.tipoDocumento}
      />
    </div>
  );
};
export default PersonaNatural;
